module.exports = __webpack_public_path__ + "static/media/telegram-plane.cc576f14.svg";